import { UiAccordionItemModel } from "../../models";

export function mockUiAccordionItemModel({
    id = "accordion-item-1234",
    type = "uiAccordionItem",
    locale = "en",
    content = mockUiAccordionItemModelContent()
}: Partial<UiAccordionItemModel> = {}): UiAccordionItemModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiAccordionItemModelContent = UiAccordionItemModel["content"];

export function mockUiAccordionItemModelContent({
    entryTitle = "Example Accordion Item",
    title = "Lorem ipsum",
    ariaLabel = "Add context to title",
    content = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas in mi consequat, tincidunt urna vel, finibus diam. Mauris vitae enim et arcu consequat mollis sed eget velit. Vivamus eu orci et enim eleifend congue. Curabitur hendrerit mattis enim. Donec consequat eu diam ut hendrerit.",
    ...optionals
}: Partial<UiAccordionItemModelContent> = {}): UiAccordionItemModelContent {
    return {
        entryTitle,
        title,
        ariaLabel,
        content,
        ...optionals
    };
}
